'use strict';

const a = [].slice.call(document.getElementsByTagName('a'));

for (const elm of a) {
  if (elm.target === '_blank') {
    let rels = elm.rel.split(' ');
    if (!~rels.indexOf('noopener')) {
      rels.push('noopener');
      elm.setAttribute('rel', rels.join(' ').trim());
    }
  }
}
